export const WEB_STORAGE = {
    ACCESS_TOKEN: 'access_token',
} as const
export const getLocalAccessToken = () =>
    localStorage.getItem(WEB_STORAGE.ACCESS_TOKEN)
export const setLocalAccessToken = (accessToken: string) =>
    localStorage.setItem(WEB_STORAGE.ACCESS_TOKEN, accessToken)